<div class="survey">
  @if (!answer) {
    <div class="survey__question">In hoeverre ben je op dit moment geholpen?</div>
    <div class="survey__options">
      @for (option of options; track option.value) {
        <label class="survey__option">
          <input
            type="radio"
            name="surveyOption"
            [value]="option.value"
            [checked]="selectedOption === option.value"
            (change)="onOptionSelect(option.value)"
          />
          <span>{{ option.label }}</span>
        </label>
      }
    </div>
    <div class="survey__actions">
      <button
        class="dvat-button dvat-button--primary"
        [disabled]="!selectedOption"
        (click)="onSubmit()"
      >
        Verstuur
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.66667 0L5.49167 1.175L10.1417 5.83333H0V7.5H10.1417L5.49167 12.1583L6.66667 13.3333L13.3333 6.66667L6.66667 0Z" fill="currentColor"/>
        </svg>
      </button>
      <button class="dvat-button dvat-button--outline" (click)="onSkip()">
        Overslaan
      </button>
    </div>
  } @else if (answer !== 'skipped' && followUpUrl && !followUpDismissed) {
    <div class="survey__question">Bedankt voor je feedback!</div>
    <div class="survey__body">Help ons om de sparringpartner verder te verbeteren.</div>
    <div class="survey__actions">
      <button
        class="dvat-button dvat-button--primary"
        type="button"
        (click)="onFollowUpStart()"
      >
        Start korte vragenlijst (3 minuten)
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.66667 0L5.49167 1.175L10.1417 5.83333H0V7.5H10.1417L5.49167 12.1583L6.66667 13.3333L13.3333 6.66667L6.66667 0Z" fill="currentColor"/>
        </svg>
      </button>
      <button class="dvat-button dvat-button--outline" (click)="onFollowUpSkip()">
        Overslaan
      </button>
    </div>
  } @else if (answer === 'skipped' || followUpDismissed) {
    <div class="survey__thanks">
      Je kunt verder chatten.
    </div>
  } @else {
    <div class="survey__thanks">
      Bedankt voor de feedback. Je kunt verder chatten.
    </div>
  }
</div>
